<!--

== Base Input

Props:

    > design
    Tipo de estilo do botão, deve ser uma string variando entre números em inglês. Existentes hoje: One.

    > text
    Texto que vai dentro do botão.


Slot:
- Utilize para inserir elementos dentro do botão, como um icone, porem ao usar o slot, o props text não irá mais funcionar.

-->

<template>
  <button
    :class="`btn btn-${design} ${loading ? 'in-load' : ''} ${
      grayscale ? 'grayscale' : ''
    }`"
    v-bind="$attrs"
    :value="value"
    v-on="inputListeners"
  >
    <span v-if="!$slots.default" :style="loading ? 'opacity: 0' : ''">{{
      text
    }}</span>

    <i class="fal fa-save" v-if="design === 'save'"></i>

    <span
      v-if="loading"
      :class="`loading ${design === 'six' ? 'loading-six' : ''}`"
    >
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </span>
    <!-- Conteúdo para ser clicado (Não obrigatório) -->
    <slot :style="loading ? 'opacity: 0' : ''"></slot>
  </button>
</template>

<script>
import { baseEvents } from '@/mixins/baseEvents.js';

export default {
  mixins: [baseEvents],
  props: {
    text: { type: String },
    design: { type: String, default: 'one' },
    loading: { type: Boolean, default: false },
    grayscale: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.btn {
  position: relative;
  text-align: center;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  padding: 10px 15px;
  font-size: 12px;
  justify-content: center;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  min-width: 45px;
}

.btn.big {
  min-height: 45px;
  min-width: 50px;
}

.btn.icon {
  padding: 15px 5px;
}

.action-buttons i {
  font-size: 15px;
}

.btn:hover {
  transition: background 0.1s ease;
}

.grayscale {
  filter: grayscale(1);
  pointer-events: none;
}

.drawer-footer button {
  height: 45px;
}

.drawer-footer .btn i {
  font-size: 14px;
}

.btn-one {
  background-color: var(--default);
  color: #fff;
  border: none;
  padding: 10px 15px;
  font-size: 12px;
  border: 1px solid var(--default);
}

.btn-one:hover {
  background-color: var(--default-hover);
}

.btn-two {
  border: 1px solid var(--default);
  color: var(--default);
  background-color: transparent;
}

.btn-two:hover {
  background-color: #333438;
}

.btn-three {
  padding: 12px 15px;
  font-size: 12px;
  line-height: 15px;
  background-color: transparent;
  border: 1px solid #515159;
  color: #ccc;
  font-weight: bold;
}

.btn-three:hover {
  background-color: #3c3e42;
}

.btn-four {
  padding: 9px 15px;
  font-size: 12px;
  background-color: var(--box);
  border: 1px solid #999999;
  color: #ccc;
}

.btn-four:hover,
.btn-four-mini:hover {
  background-color: #454548;
}

.btn-four-mini {
  border: 1px solid #99999980;
  width: 32px;
  height: 32px;
  min-width: auto;
  padding: 0;
  color: var(--label-primary);
  background-color: var(--box);
}

.btn-five {
  background-color: #9999991c;
  border: 1px solid var(--icon-inactive);
  color: var(--label-primary);
}

.btn-five i {
  color: var(--icon-inactive);
}

.btn-five:hover {
  background-color: #9999993f;
}

.btn-five:disabled {
  background: #3a3c40;
  opacity: 0.5;
}

.btn-six {
  background-color: transparent;
  border: 1px solid #999999;
  color: var(--label-primary);
}

.btn-six i {
  color: var(--icon-inactive);
}

.btn-six:hover {
  background: #44464a;
}

.btn-underline {
  outline: none;
  background: transparent;
  border: none;
}

.btn-underline span {
  color: #fff;
  border-radius: 0;
  padding-bottom: 3px;
  border-bottom: 1px solid transparent;
}

.btn-underline:hover span {
  border-color: #fff;
}

.btn-kanban {
  background-color: #fff;
  padding: 10px 15px;
  font-size: 12px;
  border: none;
  background-color: var(--box);
  border: 1px solid var(--box);
}

.btn-kanban.done {
  border-color: var(--default);
  color: var(--default);
}

.btn-kanban.finish {
  border-color: var(--success);
  color: var(--success);
}

.btn-kanban.undo {
  border-color: #999999;
  color: #999999;
}

.btn-kanban.done:hover,
.btn-kanban.finish:hover,
.btn-kanban.undo:hover {
  background-color: #414347;
}

.btn-save {
  border-radius: 50%;
  background: var(--default);
  height: 55px;
  width: 55px;
  color: #fff;
  position: fixed;
  bottom: 45px;
}

@media screen and (max-width: 991px) {
  .btn-save {
    bottom: 75px;
  }
  .no-template .btn-save {
    bottom: 25px;
  }
}

.btn-save:hover {
  background-color: var(--default-hover);
}

.btn-save i {
  font-size: 18px;
}

.btn-three.link {
  border: none;
}

.title-btn {
  margin-left: 15px;
}

.input-size {
  margin-top: 10px;
  height: 41px;
}

button:disabled,
button:disabled:hover {
  cursor: not-allowed;
  background: #808183;
  color: #ffffff;
  border-color: #808183;
}

@media screen and (max-width: 991px) {
  .btn.reverse {
    background-color: var(--box);
    color: var(--default);
    border: none;
    padding: 10px 20px;
    height: 35px;
    font-size: 12px;
  }

  .btn.reverse:hover {
    filter: brightness(0.9);
  }
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--default);
  border-radius: 5px;
}
.loading-six {
  background: var(--button-outline);
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 32px;
  height: 32px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  margin: 8px;
  border: 1px solid white;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
